export const addGlobalAlert = ({message, alertType, removeOnPageChange = true}) => dispatch => {
  dispatch({type: 'ADD_GLOBAL_ALERT', message: message, alertType: alertType, removeOnPageChange: removeOnPageChange});
};

export const removeGlobalAlert = () => dispatch => {
  dispatch({type: 'REMOVE_GLOBAL_ALERT'});
};